const Console = (() => {
  if (
    typeof window !== 'undefined' &&
    window.console != null &&
    typeof window.console === 'object'
  ) {
    return window.console;
  }
  return {};
})();

export default {
  log(str) {
    // eslint-disable-next-line no-console
    if (Console.log && str) Console.log(str);
  },
  error(err) {
    if (Console.error && err) Console.error(err);
  },
};
